export default __webpack_public_path__ + "static/media/gallery-side.048190d6.png";